var map = {
	"./basket-dialog.handlebars": 108,
	"./offers.handlebars": 109,
	"./store-closed.handlebars": 110,
	"./videopopup.handlebars": 111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;



/*****************
 ** WEBPACK FOOTER
 ** ./templates/popup ^\.\/.*\.handlebars$
 ** module id = 248
 ** module chunks = 24
 **/